import { AxiosResponse } from 'axios';
import { PreciseRulesDTO } from '../forms/rule/deserializer';
import { buildPath } from '../lib/url';
import { backendClient as client } from './clients';
import { DoseReportContextReadDTO, DoseReportFilterDTO } from './dto';
import { GetOne, RequestMethod } from './types';

export const DOSE_REPORT_PATH = 'dose-report';

export type DoseReportFormat = 'pdf' | 'html' | 'xlsx';

export const getDoseReportValidationRules: GetOne<{}, PreciseRulesDTO<DoseReportContextReadDTO>> = async ({
    config,
} = {}) => client.get(buildPath([DOSE_REPORT_PATH, 'rules']), config).then((response: AxiosResponse) => response.data);

export const generateDoseReport: RequestMethod<
    { format: DoseReportFormat; filter: DoseReportFilterDTO },
    Blob
> = async ({ format, filter, config }) =>
    client
        .post(buildPath([DOSE_REPORT_PATH, format]), filter, { ...config, responseType: 'blob' })
        .then((response: AxiosResponse) => response.data);
